import type { Product } from '../types/product'

export const products: Product[] = [
  {
    id: 'kluis-5',
    name: 'Kluis 5',
    capacity: 5.1,
    power: 3,
    modules: 1,
    price: 3995,
    tagline: 'Compact, voor kleinere huishoudens',
    bestFor: 'Tot 10 zonnepanelen · appartement of tussenwoning',
  },
  {
    id: 'kluis-10',
    name: 'Kluis 10',
    capacity: 10.2,
    power: 5,
    modules: 2,
    price: 5995,
    tagline: 'De keuze van de meeste gezinnen',
    bestFor: '10–18 zonnepanelen · gezin met 3–5 personen',
  },
  {
    id: 'kluis-15',
    name: 'Kluis 15',
    capacity: 15.3,
    power: 6,
    modules: 3,
    price: 7795,
    tagline: 'Maximaal onafhankelijk',
    bestFor: '18+ panelen · warmtepomp of elektrische auto',
  },
]
